import React, { createContext, useContext, useEffect, useState } from "react";
import axios from "axios";

const SitesContext = createContext();

export const useSites = () => useContext(SitesContext);

const geocodeAddress = async (address) => {
  const full = `${address.nr_voie || ""} ${address.type_voie || ""} ${address.voie || ""}, ${address.code_postal || ""} ${address.ville || ""}, ${address.pays || "France"}`;
  try {
    const res = await fetch(`${process.env.REACT_APP_VENDOR_SYB_API}/geocode?q=${encodeURIComponent(full)}`);
    const data = await res.json();
    if (data.length > 0) {
      return [parseFloat(data[0].lat), parseFloat(data[0].lon)];
    }
  } catch (err) {
    console.warn("Erreur géocodage :", err);
  }
  return null;
};

export const SitesProvider = ({ children }) => {
  const [sites, setSites] = useState([]);
  const [loading, setLoading] = useState(true);

  const fetchAndGeocodeSites = async () => {
    try {
      const res = await axios.get(`${process.env.REACT_APP_VENDOR_SYB_API}/sites`);
      const rawSites = res.data.sites;

      const sitesWithCoords = await Promise.all(
        rawSites.map(async (site) => {
          const loc = await geocodeAddress(site.SiteAddress);
          return loc ? { ...site, latlng: loc } : null;
        })
      );

      const validSites = sitesWithCoords.filter(Boolean);
      setSites(validSites);
    } catch (err) {
      console.error("Erreur de chargement des sites :", err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchAndGeocodeSites();
  }, []);

  return (
    <SitesContext.Provider value={{ sites, loading }}>
      {children}
    </SitesContext.Provider>
  );
};